export const manageWardSchema = {
   
    location: {
        type: "string",
        required: true,
        properties: {
            empty: "Please select geography",
        }
    },
    numberOfBeds: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter no. of beds",
            positive: "Number of beds must be at least 1",
            number: "Please enter number only",
            maxLength:{
                limit:3,
                msg: "Number of beds is not allow more than 500" 
            },     
        }  
    },


    name: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter ward name"
        }
    },

    // reasonOfExtend: {
    //     type: "string",
    //     required: true,
    //     properties: {
    //         empty: "Please select reason of extend"
    //     }
    // },

    type: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter ward type"
        }   
    },

    nhsNumber: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter NHS number",
            minLength:{
                limit:10,
                msg: "Please enter 10 digit" 
            },
            maxLength:{
                limit:10,
                msg: "Please enter 10 digit" 
            },
            positive: "Invalid value is not allowed",
            number: "Please enter number only" ,
            // positiveZero:'Invalid value is not allowed'
        } ,
      
    },

    dateOfAdmission: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter date of admission"
        }   
    },

    currentEDD: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter estimated date of discharge"
        }   
    },
    initialEDD: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter estimated date of discharge"
        }   
    },
    newEDD: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter new estimated date of discharge"
        }   
    },

    socialCareNeed: {
        type: "string",
        required: true,
        properties: {
            empty: "Please select social care need"
        }   
    },
    category: {
        type: "string",
        required: true,
        properties: {
            empty: "Please select categories"
        }   
    },
   
}